import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { PiCertificateFill } from "react-icons/pi";
import { useLazyGetCertificateQuery } from "../../Redux/app/appApis";
import Navbar from "../Navbar/Navbar";
import Cert from "../../Images/certificate.png";
import Certvalue from "../../Images/certvalue.png";
import Signature from "../../Images/Signature.jpg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const Certificate = () => {
  const [emailAddress, setEmailAddress] = useState("");
  const [showSection, setShowSection] = useState("certificate");
  const [searchError, setSearchError] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedDescription, setEditedDescription] = useState("");

  const navigate = useNavigate();

  const certificateRef = useRef(null);

  const [
    getCertificate,
    { data: certificationData, isLoading, isError, error },
  ] = useLazyGetCertificateQuery();

  const handleSearch = () => {
    if (!emailAddress.trim()) {
      setSearchError(true);
      return;
    }
    setSearchError(false);
    getCertificate(emailAddress);
    setSelectedQuiz(null);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleDownload = async () => {
    if (!certificateRef.current) return;

    const canvas = await html2canvas(certificateRef.current, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png", 1.0);

    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: [1123, 794],
    });

    const marginX = 30;

    const pdfWidth = 1123 - marginX * 2;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    const yPosition = (794 - pdfHeight) / 2;

    pdf.addImage(
      imgData,
      "PNG",
      marginX,
      yPosition,
      pdfWidth,
      pdfHeight,
      undefined,
      "FAST",
    );

    pdf.save(
      `${selectedQuiz.firstName}_${selectedQuiz.lastName}_Certificate.pdf`,
    );
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <Navbar />

      <div className="flex flex-col md:flex-row flex-1">
        <div className="w-full md:w-[20%] bg-gradient-to-b from-[#D80000] to-[#B00000] text-white p-6 shadow-xl">
          <h2 className="text-2xl font-bold mb-6">Admin Dashboard</h2>
          <ul className="space-y-2">
            <li
              className={`cursor-pointer py-3 px-4 font-semibold rounded-lg flex items-center gap-3 transition-all ${
                showSection === "approvals"
                  ? "bg-white text-[#D80000] shadow-lg"
                  : "hover:bg-white/10"
              }`}
              onClick={() => navigate("/approvals")}
            >
              <FaCheckCircle size={20} />
              <span>User Approvals</span>
            </li>
            <li
              className={`cursor-pointer py-3 px-4 font-semibold rounded-lg flex items-center gap-3 transition-all ${
                showSection === "certificate"
                  ? "bg-white text-[#D80000] shadow-lg"
                  : "hover:bg-white/10"
              }`}
              onClick={() => setShowSection("certifications")}
            >
              <PiCertificateFill size={20} />
              <span>Certifications</span>
            </li>
          </ul>
        </div>

        <div className="w-full md:w-[80%] bg-white p-8">
          <div className="w-full mb-8">
            <h2 className="text-3xl font-bold mb-6 text-gray-800">
              Certifications
            </h2>
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
              <div className="flex items-center border-2 border-gray-300 rounded-lg p-1 w-full md:w-1/2 lg:w-1/3 shadow-sm hover:border-red-400 transition-colors">
                <input
                  type="email"
                  placeholder="Enter email address..."
                  className="flex-grow px-2 py-2 focus:outline-none text-gray-700"
                  value={emailAddress}
                  onChange={(e) => {
                    setEmailAddress(e.target.value);
                    setSearchError(false);
                  }}
                  onKeyPress={handleKeyPress}
                />
                <button
                  className="bg-red-600 text-white px-2 py-2 rounded-md hover:bg-red-700 transition-colors font-semibold shadow-md hover:shadow-lg"
                  onClick={handleSearch}
                >
                  Generate
                </button>
              </div>

              {selectedQuiz && (
                <div className="flex gap-2">
                  {!isEditing ? (
                    <button
                      onClick={() => setIsEditing(true)}
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                    >
                      Edit
                    </button>
                  ) : (
                    <button
                      onClick={() => setIsEditing(false)}
                      className="bg-green-600 text-white px-4 py-2 rounded-lg"
                    >
                      Save
                    </button>
                  )}

                  <button
                    onClick={handleDownload}
                    className="bg-green-600 text-white px-2 py-2 rounded-lg hover:bg-green-700 transition-colors font-semibold shadow-md hover:shadow-lg whitespace-nowrap"
                  >
                    Download Certificate
                  </button>
                </div>
              )}

              {/* {selectedQuiz && (
                <button
                  onClick={handleDownload}
                  className="bg-green-600 text-white px-2 py-2 rounded-lg hover:bg-green-700 transition-colors font-semibold shadow-md hover:shadow-lg whitespace-nowrap"
                >
                  Download Certificate
                </button>
              )} */}
            </div>

            {searchError && (
              <p className="text-red-500 mt-3 text-sm font-medium">
                Email is required.
              </p>
            )}

            {isError && (
              <p className="text-red-500 mt-3 text-sm font-medium">
                {error?.error?.message || "Failed to fetch certificate details"}
              </p>
            )}
          </div>

          {isLoading && (
            <div className="flex justify-center items-center py-20">
              <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                <p className="text-blue-500 text-lg font-medium">
                  Fetching certification details...
                </p>
              </div>
            </div>
          )}

          {!isLoading && !selectedQuiz && certificationData?.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              {certificationData.map((cert, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedQuiz(cert)}
                  className="cursor-pointer bg-white border rounded-xl shadow-[0_8px_20px_rgba(0,0,0,0.12)] hover:shadow-xl transition p-6 text-center"
                >
                  <h3 className="text-lg font-bold text-red-600">
                    {cert.quizType}
                  </h3>
                  <p className="mt-4 text-xs text-blue-600 font-semibold">
                    Click to view certificate
                  </p>
                </div>
              ))}
            </div>
          )}

          {selectedQuiz && (
            <div className="flex justify-center mt-8">
              <div className="bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.15)] p-6 hover:shadow-[0_25px_70px_rgba(0,0,0,0.2)] transition-shadow duration-300">
                <div
                  ref={certificateRef}
                  className="relative w-[680px] h-[500px] md:h-[460px] md:w-[680px] rounded-xl bg-contain bg-center bg-no-repeat"
                  style={{ backgroundImage: `url(${Cert})` }}
                >
                  <div className="absolute inset-0 px-8 py-10 flex flex-col ml-6">
                    <div className="flex justify-center mb-4">
                      <img
                        src={Certvalue}
                        alt="CertValue Logo"
                        className="h-9 w-auto -mt-2"
                      />
                    </div>

                    <div className="flex-1 flex flex-col items-center justify-center space-y-2 px-12 ">
                      <div className="text-center space-y-1">
                        <p className="text-sm font-bold uppercase tracking-wider text-gray-700 mb-1">
                          CERTIFICATE OF
                        </p>
                        <div
                          contentEditable={isEditing}
                          suppressContentEditableWarning={true}
                          onBlur={(e) => setEditedTitle(e.target.innerText)}
                          className={`text-xl font-bold text-red-600 tracking-wide text-center ${
                            isEditing
                              ? "outline-none border-b border-gray-400"
                              : ""
                          }`}
                        >
                          {editedTitle ||
                            (selectedQuiz.quizType
                              ? selectedQuiz.quizType.split(" ")[0] +
                                " Training"
                              : "ISO Training")}
                        </div>
                      </div>

                      <div className="text-center space-y-0 mt-6">
                        <p className="text-xs uppercase tracking-widest text-gray-600 font-semibold">
                          PROUDLY PRESENTED TO
                        </p>
                        <h2 className="text-lg font-bold text-gray-900 tracking-wide">
                          {selectedQuiz.firstName} {selectedQuiz.lastName}
                        </h2>
                      </div>

                      <div className="mt-4 text-center ml-12">
                        <div
                          contentEditable={isEditing}
                          suppressContentEditableWarning={true}
                          onBlur={(e) =>
                            setEditedDescription(e.target.innerText)
                          }
                          className={`text-sm text-gray-700 leading-relaxed ${
                            isEditing
                              ? "outline-none border border-gray-300 p-2 rounded"
                              : ""
                          }`}
                        >
                          {editedDescription || (
                            <>
                              In recognition of the successful completion of
                              {"  "}
                              {/* <span className="font-bold text-gray-900"> */}
                                {selectedQuiz.quizType
                                  ? selectedQuiz.quizType.split(" ")[0]
                                  : "ISO"}{" "}
                                Training
                              {/* </span>{" "} */}
                              certification, demonstrating compliance with
                              international management standards, on{" "}
                              {/* <span className="font-bold text-gray-900"> */}
                                {selectedQuiz.issueDate
                                  ? new Date(
                                      selectedQuiz.quizDate,
                                    ).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    })
                                  : new Date().toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    })}
                              {/* </span> */}
                              .
                            </>
                          )}
                        </div>
                      </div>

                      <div className="mt-6 flex flex-col items-center">
                        <img
                          src={Signature}
                          alt="Signature"
                          className="h-14 w-auto -mb-4"
                        />
                        <div className="border-t border-gray-700 w-48 mb-2"></div>
                        <p className="text-sm font-bold text-gray-800 mb-1">
                          Director, Training & Certification
                        </p>
                        <img
                          src={Certvalue}
                          alt="CertValue"
                          className="h-6 w-auto"
                        />
                      </div>

                      <div className="mt-4 text-center ml-2">
                        <p className="text-xs text-gray-600 leading-tight">
                          #4025–4026, 1st floor, 6th cross, Jayanagar 7th west
                          block,
                          <br />
                          Bangalore, India, 560082
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Certificate;
